// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"f3c2f9af","633":"04e5bf1b","967":"4c1ad84d"}[chunkId] + ".chunk.js";
};